import React, { useState } from "react";
import "../scss/pages/contact.scss";
import Header from "../../components/layout/header";
import worldImage from "../../images/worldwide.PNG";

const Contact = () => {
  const [activeTab, setActiveTab] = useState("officeFinder");

  return (
    <>
      <Header />
      <section className="contact-page">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <span>🏠 &gt; CONTACT</span>
        </div>

        {/* Heading */}
        <h2>Find your local Offices and Contacts</h2>
        <p>
          Search and find your local Hellmann office and contact persons. With a
          worldwide network of 489 offices in 173 countries around the world, we
          are always just a click away.
        </p>

        {/* Navigation Tabs */}
        <div className="contact-tabs">
          <button
            className={activeTab === "contactUs" ? "active" : ""}
            onClick={() => setActiveTab("contactUs")}
          >
            Contact-Us
          </button>
          <button
            className={activeTab === "officeFinder" ? "active" : ""}
            onClick={() => setActiveTab("officeFinder")}
          >
            OFFICE FINDER
          </button>
        </div>

        {/* Content based on active tab */}
        <div className="tab-content">
          {activeTab === "contactUs" ? (
            <form className="contact-form">
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
              <textarea placeholder="Your Message" required></textarea>
              <button type="submit">Send Message</button>
            </form>
          ) : (
            <div className="map-container">
              <iframe
                title="Contact Map"
                src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d115856.22040944545!2d66.91915165508273!3d24.846531706708955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3eb33fae4df7c769%3A0xd830848b2cc0cc91!2sADD.%3A%20ONB%20A-8%2FF%202ND%20FLOOR%2C%20MEHER%20SONS%20ESTATE%2C%20Talpur%20Road%2C%20Lalazar%2C%20Karachi%2C%2074000!3m2!1d24.846554299999998!2d67.0015532!5e0!3m2!1sen!2s!4v1742237957489!5m2!1sen!2s"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          )}
        </div>
      </section>
      <footer>
        <div className="background">
          <img src={worldImage} alt="world" />
          <div className="footer-content">
            <ul className="footer-content__list">
              <li>Home</li>
              <li>Services</li>
              <li>Blog</li>
              <li>About Us</li>
              <li>Contact Us</li>
              <li>Privacy Policy</li>
            </ul>
            <div className="footer-content__social">
              <p>WHISTLEBLOWING</p>
              <p>LEGAL</p>
              <p>PRIVACY</p>
              <p>COOKIES</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Contact;
